/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('region.projected-openings')
 */
import { RegionLayout } from 'page-components/region/_layout';

import Component, { getRegionProjectedOpeningsPageServerSideProps } from 'page-components/region/projected-openings';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchRegionSlugs } from 'util/fetchStaticPageRegion';
import { isMainLocale } from 'util/i18nFlags';
import { packPaths } from 'util/packPaths'; */

export const getServerSideProps = propsWithI18NSSR(getRegionProjectedOpeningsPageServerSideProps);
/* export const getStaticPaths = async () => packPaths(
  isMainLocale() ? (
    await fetchRegionSlugs('region.projected-openings')
  ).map((reg) => ({ region: reg.slug })) : [],
); */

export default Object.assign(Component, { Layout: RegionLayout });
